import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConfigurationState {
  /** Opaque configuration payload from services/configuration RTK API */
  configuration: Record<string, unknown> | null;
  company: Record<string, unknown> | null;
  error: string | null;
}

const initialState: ConfigurationState = {
  configuration: null,
  company: null,
  error: null,
};

const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfiguration: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.configuration = action.payload;
      state.error = null;
    },
    setCompany: (state, action: PayloadAction<any>) => {
      state.company = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setConfiguration, setCompany, setError } =
  configurationSlice.actions;
export default configurationSlice.reducer;
